<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('PERSONS.PERSONS_MANAGEMENT') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="indigo"
        @click="$router.push({ name: 'persons.create' })"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('PERSONS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <persons
        :persons="persons"
        @show="showedPerson"
        @refresh="refreshData"
      ></persons>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Persons from '@/modules/persons/components/PersonsList';

export default {
  name: 'PersonsPage',

  components: {
    Persons
  },

  data: () => ({
    persons: undefined
  }),

  methods: {
    ...mapActions('person', ['retrievePersons']),
    refreshData(params) {
      this.retrievePersons(params)
        .then(({ data }) => {
          this.persons = data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    showedPerson(person) {
      this.$router.push({ name: 'persons.show', params: { id: person.id } });
    }
  }
};
</script>
